import React from 'react';

import { Link as ChakraUILink } from '@chakra-ui/react';
import { Link as ReactRouterDomLink } from 'react-router-dom';

export const Link = (props) => (
  <ChakraUILink as={ReactRouterDomLink} {...props} />
);
